<template>
    <div>
        <EditorBlock title="Editor" :block="block">
            <template #cardbody>
                <div class="row">
                    <div class="col-3">
                        <b-btn @click="toggleEdit()" class="m-2" :variant="editing ? 'primary': 'success'">
                            <span v-if="!editing">Edit</span>
                            <span v-if="editing">View</span>
                        </b-btn>
                    </div>
                    <div class="col-9">
                        <b-btn
                            v-b-popover.hover.top="'Our site uses bootstrap and any bootstrap classes you add to this html block will be applied!'"
                            title="Bootstrap Classes"
                            href="https://getbootstrap.com/docs/3.4/css/#overview"
                            target="_blank"
                            variant="link"
                            class="float-right">
                            Bootstrap
                        </b-btn>
                        <span class="float-right mt-1" v-b-popover.hover.top="'You can include custom <style> tags.'" title="Tips & Tricks">
                            <font-awesome-icon :icon="['fas', 'info-circle']"></font-awesome-icon>
                        </span>
                    </div>
                </div>
                <div class="row pt-2" v-show="editing">
                    <prism-editor class="prism_editor"
                                  v-model="html"
                                  language="html"
                                  :tabSize="4"
                                  line-numbers
                                  :highlight="highlighter"/>
                </div>
                <div v-show="!editing" v-html="html">

                </div>
            </template>
        </EditorBlock>
    </div>
</template>

<style lang="scss" scoped>
.form-control {
    min-height: 2.5rem;
}
/* required class */
.my-editor {
    /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
    background: #2d2d2d;
    color: #ccc;

    /* you must provide font-family font-size line-height. Example: */
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
    outline: none;
}
</style>

<script>
import EditorBlock from "@/components/dashboard/storeadmin/EditorBlock";

import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-css';
import 'prismjs/themes/prism.css';

export default {
    data: () => ({
        editor: null,
        html: "",
        editing: true,
    }),
    props: ['block'],
    components: {
        EditorBlock,
        PrismEditor,
    },
    watch: {
        html() {
            this.block.value = this.html;
            this.$emit('input', this.html);
        }
    },
    methods: {
        highlighter(code) {
            return highlight(code, languages.html, 'html');
        },
        toggleEdit() {
            this.editing = !this.editing;
        }
    },
    mounted () {
        this.html = this.block.value;
    }
}
</script>
